import { FC, MouseEvent, useState } from 'react'
import styled from 'styled-components'
import {
  CoverLetterScrap_CoverLetterFragment,
  CoverLetterScrap_CurrentUserFragment,
} from 'generated/graphql'
import { mobileBreakPoint } from 'app.styled/media'
import Link from 'components/Link'
import BookMarkIcon from 'svgIcons/BookMark'
import CoverLetterScrap from '../CoverLetterScreen/CoverLetterScrap'
import PopperWithArrow from './PopperWithArrow'

interface ScrapButtonWithPopperProps {
  coverLetter?: CoverLetterScrap_CoverLetterFragment | null
  currentUser?: CoverLetterScrap_CurrentUserFragment | null
}

const ScrapButtonWithPopper: FC<ScrapButtonWithPopperProps> = ({
  coverLetter,
  currentUser,
}) => {
  const [openScrapPopper, setOpenScrapPopper] = useState<boolean>(false)
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null)

  const id = openScrapPopper ? 'cover-letter-transitions-popper' : undefined

  return (
    <StyledWrapper>
      <CoverLetterScrap coverLetter={coverLetter} currentUser={currentUser}>
        {({ scrapCoverLetter, loading }) => {
          const handleClick = (event: MouseEvent<HTMLButtonElement>) => {
            scrapCoverLetter()
            setOpenScrapPopper(!!currentUser && !coverLetter?.isScrapped)
            setAnchorEl(event.currentTarget)

            setTimeout(() => {
              setOpenScrapPopper(false)
            }, 5000)
          }

          return (
            <>
              <StyledScrapButton
                onClick={handleClick}
                disabled={loading}
                data-is-on={coverLetter?.isScrapped}
              >
                <BookMarkIcon
                  isOn={!!coverLetter?.isScrapped}
                  className="bookmark-icon"
                  strokeType="#666666"
                />
                <StyledButtonText>
                  {coverLetter?.isScrapped ? '스크랩완료' : '스크랩하기'}
                </StyledButtonText>
              </StyledScrapButton>
              <PopperWithArrow
                open={openScrapPopper}
                anchorEl={anchorEl}
                id={id}
              >
                <p className="scrap-alarm">
                  해당 자소서가 스크랩 페이지에 저장됐습니다.
                </p>
                <Link
                  href={'/accounts/scrap?p=1&tab=COVER_LETTER_AND_PARAGRAPH'}
                  className="link"
                >
                  스크랩 페이지 확인
                </Link>
              </PopperWithArrow>
            </>
          )
        }}
      </CoverLetterScrap>
    </StyledWrapper>
  )
}

export default ScrapButtonWithPopper

const StyledWrapper = styled.div`
  .link {
    text-decoration: underline;
  }

  .scrap-alarm {
    font-weight: normal;
    padding-bottom: 10px;
  }
`

const StyledScrapButton = styled.button`
  cursor: pointer;
  color: #666666;
  border: 1px solid #cccccc;
  background-color: #fff;
  display: flex;
  min-width: 120px;
  height: 50px;
  align-items: center;
  gap: 10px;
  justify-content: center;
  border-radius: 5px;
  font-size: 16px;
  box-sizing: border-box;
  font-weight: bold;
  line-height: 1.5;

  ${mobileBreakPoint} {
    padding: 0px 15px;
    min-width: 50px;
    gap: 0;
  }

  &[data-is-on='true'] {
    color: #01a0ff;
    border-color: #cccccc; /* 스크랩된 상태에서도 회색 테두리 유지 */
  }

  > .bookmark-icon {
    color: inherit; /* 부모의 color 속성을 상속받도록 변경 */
    width: 12px;
    height: 16px;
    flex-shrink: 0;
  }
`

const StyledButtonText = styled.span`
  display: inline;

  ${mobileBreakPoint} {
    display: none;
  }
`
